interface ErrorsState {
  isError: boolean;
  errorCode: number | null;
  errorMessage: string;
}

interface CompletionsState {
  [key: string]: unknown;
}

interface NewFormState {
  errors: ErrorsState;
  isPassport: boolean;
  isAddress: boolean;
  isWork: boolean;
  result: boolean;
  calculatorSettings: Record<string, any>;
  addBankAccountSuccess: boolean;
  addWalletSuccess: boolean;
  completions: CompletionsState;
  applicationId: string | null;
  dictionaries: Record<string, unknown>;
  additionalQuestionsDictionary: any | null;
  productId: string | null;
}

const SET_ERRORS = "SET_ERRORS";
const SET_PRODUCT_ID = "SET_PRODUCT_ID";
const SET_RESULT = "SET_RESULT";
const SET_IS_PASSPORT = "SET_IS_PASSPORT";
const SET_IS_ADDRESS = "SET_IS_ADDRESS";
const SET_IS_WORK = "SET_IS_WORK";
const ADD_BANK_ACCOUNT_SUCCESS = "ADD_BANK_ACCOUNT_SUCCESS";
const ADD_WALLET_SUCCESS = "ADD_WALLET_SUCCESS";
const SET_COMPLETIONS = "SET_COMPLETIONS";
const SET_APPLICATION_ID = "SET_APPLICATION_ID";
const SET_DICTIONARIES = "SET_DICTIONARIES";
const SET_ADDITIONAL_QUESTIONS_DICTIONARY =
  "SET_ADDITIONAL_QUESTIONS_DICTIONARY";
const SET_CALCULATOR_SETTINGS = "SET_CALCULATOR_SETTINGS";
const RESET = "RESET";

interface SetErrorsAction {
  type: typeof SET_ERRORS;
  payload: ErrorsState;
}

interface SetProductIdAction {
  type: typeof SET_PRODUCT_ID;
  payload: string | null;
}

interface SetResultAction {
  type: typeof SET_RESULT;
  payload: boolean;
}

interface SetIsPassportAction {
  type: typeof SET_IS_PASSPORT;
  payload: boolean;
}

interface SetIsAddressAction {
  type: typeof SET_IS_ADDRESS;
  payload: boolean;
}

interface SetIsWorkAction {
  type: typeof SET_IS_WORK;
  payload: boolean;
}

interface AddBankAccountSuccessAction {
  type: typeof ADD_BANK_ACCOUNT_SUCCESS;
  payload: boolean;
}

interface AddWalletSuccessAction {
  type: typeof ADD_WALLET_SUCCESS;
  payload: boolean;
}

interface SetCompletionsAction {
  type: typeof SET_COMPLETIONS;
  payload: {
    key: string;
    completions: unknown;
  };
}

interface SetApplicationIdAction {
  type: typeof SET_APPLICATION_ID;
  payload: string | null;
}

interface SetDictionariesAction {
  type: typeof SET_DICTIONARIES;
  payload: Record<string, unknown>;
}

interface SetAdditionalQuestionsDictionaryAction {
  type: typeof SET_ADDITIONAL_QUESTIONS_DICTIONARY;
  payload: any | null;
}

interface SetCalculatorSettingsAction {
  type: typeof SET_CALCULATOR_SETTINGS;
  payload: Record<string, any>;
}

interface ResetAction {
  type: typeof RESET;
}

type NewFormAction =
  | SetErrorsAction
  | SetProductIdAction
  | SetResultAction
  | SetIsPassportAction
  | SetIsAddressAction
  | SetIsWorkAction
  | AddBankAccountSuccessAction
  | AddWalletSuccessAction
  | SetCompletionsAction
  | SetApplicationIdAction
  | SetDictionariesAction
  | SetAdditionalQuestionsDictionaryAction
  | SetCalculatorSettingsAction
  | ResetAction;

const initialState: NewFormState = {
  errors: {
    isError: false,
    errorCode: null,
    errorMessage: "",
  },
  isPassport: false,
  isAddress: false,
  isWork: false,
  result: false,
  calculatorSettings: {},
  addBankAccountSuccess: false,
  addWalletSuccess: false,
  completions: {},
  applicationId: null,
  dictionaries: {},
  additionalQuestionsDictionary: null,
  productId: null,
};

export const newFormReducer = (
  state: NewFormState = initialState,
  action: NewFormAction
): NewFormState => {
  switch (action.type) {
    case SET_ERRORS:
      return { ...state, errors: action.payload };
    case SET_PRODUCT_ID:
      return { ...state, productId: action.payload };
    case SET_RESULT:
      return { ...state, result: action.payload };
    case SET_IS_PASSPORT:
      return { ...state, isPassport: action.payload };
    case SET_IS_ADDRESS:
      return { ...state, isAddress: action.payload };
    case SET_IS_WORK:
      return { ...state, isWork: action.payload };
    case ADD_BANK_ACCOUNT_SUCCESS:
      return { ...state, addBankAccountSuccess: action.payload };
    case ADD_WALLET_SUCCESS:
      return { ...state, addWalletSuccess: action.payload };
    case SET_COMPLETIONS:
      return {
        ...state,
        completions: {
          ...state.completions,
          [action.payload.key]: action.payload.completions,
        },
      };
    case SET_APPLICATION_ID:
      return { ...state, applicationId: action.payload };
    case SET_DICTIONARIES:
      return { ...state, dictionaries: action.payload };
    case SET_ADDITIONAL_QUESTIONS_DICTIONARY:
      return { ...state, additionalQuestionsDictionary: action.payload };
    case SET_CALCULATOR_SETTINGS:
      return { ...state, calculatorSettings: action.payload };
    case RESET:
      return initialState;
    default:
      return state;
  }
};
